/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_3_PickInputs */

const en_pc_alt_pick_3_pick = /** @type {(inputs: Pc_Alt_Pick_3_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFsam Basic or PdfCraft on the desktop. For a one-off job, the merge and split tools on our home page run in your browser too.`)
};

const zh_pc_alt_pick_3_pick = /** @type {(inputs: Pc_Alt_Pick_3_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面上用 PDFsam Basic 或 PdfCraft。偶尔处理一次的话，本站首页的合并与拆分工具也在浏览器中本地运行。`)
};

/**
* | output |
* | --- |
* | "PDFsam Basic or PdfCraft on the desktop. For a one-off job, the merge and split tools on our home page run in your browser too." |
*
* @param {Pc_Alt_Pick_3_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_3_pick = /** @type {((inputs?: Pc_Alt_Pick_3_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_3_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_3_pick(inputs)
	return zh_pc_alt_pick_3_pick(inputs)
});
export { pc_alt_pick_3_pick as "pc.alt.pick.3.pick" }